<script>
import _ from 'lodash'
import {addProductQuantities} from "@/utils/orderAvailability";

export default {
    name: "ProductSetMixin",
    computed: {
        orders () {
            let userId = this.$store.getters['identity/getUserId'];
            if (userId === null) {
                this.snackbarError(this.$t('snackbar.identity_check_failed'));
                return [];
            }

            let warehouseId = this.$store.getters['warehouse/getWarehouseId'](userId);
            if (warehouseId === null) {
                // this.snackbarError(this.$t('snackbar.warehouses.not_selected'));
                return [];
            }

            return this.getBulkOrders(userId, warehouseId);
        },
        numberOfProductSets () {
            return this.productSets.length;
        },
        productSets () {
            // aggregate all recipients from all orders
            let recipients = [];
            this.orders.forEach(order => {
                order.recipients.forEach(recipient => {
                    if (!recipients.find(r => r.address_id === recipient.address_id)) {
                        recipients.push(recipient);
                    }
                });
            });

            /**
             * key: {
             *   productSet: {...},
             *   recipients: [...]
             * }
             */
            let productSets = {};

            // get all products for given recipient
            recipients.forEach(recipient => {
                let productSet = {};
                this.orders.forEach(order => {
                    if (order.recipients.find(r => r.address_id === recipient.address_id)) {
                        order.order.forEach(product => {
                            if (product.external_id in productSet) {
                                productSet[product.external_id].quantity
                                    = addProductQuantities(
                                        productSet[product.external_id].quantity,
                                        product.quantity
                                    );
                            } else {
                                productSet[product.external_id] = _.cloneDeep(product);
                                productSet[product.external_id].quantity
                                    = addProductQuantities(0, product.quantity);
                            }
                        });
                    }
                });
                const hash = this.productSetHash(productSet);
                if (hash in productSets) {
                    if (!productSets[hash].recipients.find(r => r.address_id === recipient.address_id)) {
                        productSets[hash].recipients.push(recipient);
                    }
                } else {
                    productSets[hash] = {
                        productSet: productSet,
                        recipients: [recipient]
                    };
                }
            });

            return Object.values(productSets);
        }
    },
    methods: {
        productSetHash (productSet) {
            let hash = Object.values(productSet)
                .map(product => "" + product.external_id + "-" + product.quantity)
                .sort()
                .join(";");
            return hash;
        }
    }
}
</script>
